var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex items-center justify-between mt-2"},[_c('page-header',{attrs:{"heading":"Domains","breadcrumb":"Settings >> Domains "}})],1),_c('div',{staticClass:"bg-white shadow py-6 mt-8"},[_c('domains-table')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }